import { useState } from 'react';

import { Heading16 } from 'approot/shared/styles/typography.style';
import Text from 'approot/shared/styles/typography/text';
import { RatingStars } from 'approot/shared/feedback-survey/rating-stars/rating-stars';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import NativeFeedbackSurveyModal from './native-feedback-survey-modal';
import * as Styled from './native-feedback-survey.style';
import { ScreenReaderOnly } from 'approot/shared/styles/global.styles';
import { useAccessibleHeading } from 'approot/shared/ally/accessible-heading';
import {
  SecondaryButton,
  SecondaryButtonLink,
} from '../styles/buttons/secondary-button.style';
import { NativeFeedbackSurveyProps } from './native-feedback-survey.constants';

const NativeFeedbackSurvey = ({
  feature,
  contentName,
  contentType,
  contentId,
  classId,
  exitLink,
  exitLabel,
}: NativeFeedbackSurveyProps) => {
  const { openModal, isVisible, closeModal } = useSimpleModalState();
  const { registerHeading } = useAccessibleHeading();

  const [rating, setRating] = useState<number>(0);
  const [hasSubmittedFeedback, setHasSubmittedFeedback] =
    useState<boolean>(false);

  const handleRating = () => {
    if (rating > 0) {
      openModal();
    }
  };

  const lessonLink = `${window.location.origin}${exitLink}`;

  return (
    <>
      {hasSubmittedFeedback ? (
        <Styled.FeedbackSubmittedWrapper>
          <ScreenReaderOnly as="h1" tabIndex={-1} ref={registerHeading}>
            Feedback completed for {contentName}
          </ScreenReaderOnly>
          <Heading16 as="h2" marginBottom={0}>
            Thanks for your feedback!
          </Heading16>
          <Text $marginBottom={16} $align="center">
            We really appreciate you taking the time, it helps us keep improving
            our {contentType}s for you and your class.
          </Text>
          <SecondaryButtonLink to={exitLink} $isSmall>
            {exitLabel}
          </SecondaryButtonLink>
        </Styled.FeedbackSubmittedWrapper>
      ) : (
        <>
          <Styled.FeedbackSurveyWrapper>
            <ScreenReaderOnly as="h1" tabIndex={-1} ref={registerHeading}>
              Feedback survey for ${contentName}
            </ScreenReaderOnly>
            <Heading16 as="h2" marginBottom={0} $fontWeight="normal">
              Rate this {contentType}
            </Heading16>
            <RatingStars rating={rating} onRatingChange={setRating} />
            <SecondaryButton
              type="button"
              $isSmall
              onClick={handleRating}
              disabled={rating === 0}
            >
              Submit Rating
            </SecondaryButton>

            <NativeFeedbackSurveyModal
              feature={feature}
              isVisible={isVisible}
              closeModal={closeModal}
              contentName={contentName}
              contentType={contentType}
              contentId={contentId!}
              classId={classId!}
              rating={rating}
              setHasSubmittedFeedback={setHasSubmittedFeedback}
              lessonLink={lessonLink}
            />
          </Styled.FeedbackSurveyWrapper>
        </>
      )}
    </>
  );
};

export default NativeFeedbackSurvey;
